import React, { useContext, useState, useEffect } from 'react'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import { Link, useHistory } from 'react-router-dom'
import {
    currencyFormat,
    dateFormatFront,
    handleRedirectInternal,
} from '../../../Product/common/components'
import { Redirect } from 'react-router-dom'
import ProductContext from '../../../Product/context/product/productContext'
import AuthContext from '../../../Product/context/auth/authContext'
import { Pagination } from '@material-ui/lab'
import Timer from '../../../Product/common/timer'
import { Button } from '@material-ui/core'
import MultisellerSlider from '../../../Component/SlidePanel/MultisellerSlider'
import NoRecordsFound from '../../../Product/components/atoms/NoRecordsFound'
import { getImageurl, imageError } from '../../../utils/commonFunctions'
import Loader from '../../../assets/loader'

const AllBids = (props) => {
    const productContext = useContext(ProductContext)
    const { seller_allproducts, getAllSellerProducts } = productContext

    const authContext = useContext(AuthContext)
    const { isAuthenticated, isAdmin } = authContext
    const [selectedProduct, setSelectedProduct] = useState(null)

    const [loading, setLoading] = useState(true)
    const history = useHistory()
    const [toInvoice, settoInvoice] = useState(false)
    const [toInvoiceID, settoInvoiceID] = useState({
        inv_id: 0,
        user_id: 0,
    })

    const [search, setSearch] = useState({
        status: props.page,
        limit: 10,
        page: 1,
    })
    useEffect(() => {
        setLoading(false)
    }, [seller_allproducts])
    const onHandlePage = (event, value) => {
        setSearch({ ...search, page: value })
    }

    const handleClose = () => setSelectedProduct(null)

    const handleClick = async (id) => {
        setSelectedProduct(id)
    }

    useEffect(() => {
        if (isAuthenticated) {
            setLoading(true)
            getAllSellerProducts(search)
        }
    }, [search, isAuthenticated])

    return (
        <div>
            {toInvoice ? (
                <Redirect to={`invoice/${toInvoiceID.inv_id}/${toInvoiceID.user_id}`} />
            ) : null}
            {loading ? (
                <div className="text-center">
                    <Loader />
                </div>
            ) : seller_allproducts.result.length ? (
                <>
                    <div className="table-responsive">
                        <table className="table table-hover">
                            <thead>
                                <tr>
                                    <th className="numCell">#</th>
                                    <th>Image</th>
                                    <th>Product Name</th>
                                    {props.page !== 'draft' ? <th>Time left</th> : null}
                                    <th>Price</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            {seller_allproducts.result.map((item, index) => {
                                return (
                                    <>
                                        <tbody>
                                            <tr>
                                                <td>{index + 1}</td>
                                                <td>
                                                    <img
                                                        className="pro-img"
                                                        src={getImageurl(
                                                            item.content_head1,
                                                            item.avatar,
                                                        )}
                                                        alt={item.title}
                                                        width="65"
                                                        height="65"
                                                        onError={(e) =>
                                                            (e.target.src = imageError())
                                                        }
                                                    />
                                                </td>
                                                <td>
                                                    {item.title}{' '}
                                                    {item.auctionlottitle
                                                        ? ' (' + item.auctionlottitle + ')'
                                                        : null}
                                                </td>
                                                {props.page !== 'draft' ? (
                                                    <td>
                                                        {item.market_status === 'open' ? (
                                                            <>
                                                                <Timer
                                                                    date_added={item.date_added}
                                                                    date_closed={item.date_closed}
                                                                    withText={1}
                                                                ></Timer>
                                                            </>
                                                        ) : (
                                                            <>
                                                                {'Date Closed'} :
                                                                {dateFormatFront(item.date_closed)}
                                                            </>
                                                        )}
                                                    </td>
                                                ) : null}
                                                <td>
                                                    {item.market_status === 'sold' ? (
                                                        <>
                                                            <div>
                                                                {'Hammer Price'} :{' '}
                                                                <b>
                                                                    {currencyFormat(
                                                                        parseInt(
                                                                            item.content_head1,
                                                                        ),
                                                                    ) > 0
                                                                        ? parseFloat(
                                                                              parseInt(
                                                                                  item.buynowamount,
                                                                              ) *
                                                                                  parseInt(
                                                                                      item.qty,
                                                                                  ),
                                                                          ).toFixed(2)
                                                                        : currencyFormat(
                                                                              item.buynowamount,
                                                                          )}
                                                                </b>
                                                                {item.buynowpaid === 1
                                                                    ? ' (Paid)'
                                                                    : ' (Unpaid)'}
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <>
                                                            {item.auction === 1 ? (
                                                                <>
                                                                    {parseInt(item.bidcount) ===
                                                                    0 ? (
                                                                        <div>
                                                                            Start Price :
                                                                            <b>
                                                                                {currencyFormat(
                                                                                    item.sprice,
                                                                                )}
                                                                            </b>
                                                                        </div>
                                                                    ) : (
                                                                        <div>
                                                                            Current Price :
                                                                            <b>
                                                                                {currencyFormat(
                                                                                    item.wprice,
                                                                                )}
                                                                            </b>
                                                                        </div>
                                                                    )}
                                                                </>
                                                            ) : item.buynow === 1 ? (
                                                                <div>
                                                                    Buy Now Price :
                                                                    <b>
                                                                        {currencyFormat(
                                                                            item.bprice,
                                                                        )}
                                                                    </b>
                                                                </div>
                                                            ) : (
                                                                '--'
                                                            )}
                                                        </>
                                                    )}

                                                    {/* {item.buynow !== 0 ? (
                                                        <>
                                                            <div>
                                                                {'Quantity'} :<b>{item.qty}</b>
                                                            </div>
                                                        </>
                                                    ) : null} */}
                                                </td>
                                                <td>{item.market_status}</td>
                                                <td>
                                                    {item.market_status === 'open' &&
                                                    parseInt(item.bidcount) <= 0 ? (
                                                        <Button
                                                            variant="outlined"
                                                            onClick={() =>
                                                                handleRedirectInternal(
                                                                    history,
                                                                    `edit-project/${item.id}`,
                                                                )
                                                            }
                                                        >
                                                            Edit
                                                        </Button>
                                                    ) : (
                                                        <Button
                                                            variant="outlined"
                                                            onClick={() => handleClick(item.id)}
                                                        >
                                                            View
                                                        </Button>
                                                    )}

                                                    {item.market_status === 'sold' ? (
                                                        <>
                                                            {item.buynowpaid === 1 ? (
                                                                <>
                                                                    <Button
                                                                        variant="outlined"
                                                                        className="ml-2"
                                                                        onClick={() =>
                                                                            handleRedirectInternal(
                                                                                history,
                                                                                `invoice/${item.common_invoice}/${item.buynowuser_id}`,
                                                                            )
                                                                        }
                                                                    >
                                                                        View Invoice
                                                                    </Button>
                                                                </>
                                                            ) : (
                                                                <></>
                                                            )}
                                                        </>
                                                    ) : null}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </>
                                )
                            })}
                        </table>
                    </div>
                    <div className="d-flex mt-3">
                        <div className="ml-auto mt-2">
                            {'Showing'} {search.limit * (search.page - 1) + 1} -{' '}
                            {search.limit * search.page > seller_allproducts.length
                                ? seller_allproducts.length
                                : search.limit * search.page}{' '}
                            of {seller_allproducts.length}
                        </div>
                        <Pagination
                            count={Math.ceil(seller_allproducts.length / search.limit)}
                            page={search.page}
                            onChange={onHandlePage}
                        />
                    </div>
                    <MultisellerSlider
                        selectedLot={selectedProduct}
                        handleClose={handleClose}
                        type={props.type ? props.type : ''}
                    />
                </>
            ) : (
                <>
                    <NoRecordsFound />
                </>
            )}
        </div>
    )
}

export default AllBids
